// extracted by mini-css-extract-plugin
module.exports = {"rightSidebarFooter":"ApplicantDetailSidebarFooter_rightSidebarFooter__dFGYK","footerContent":"ApplicantDetailSidebarFooter_footerContent__3jZKS"};